import React from 'react'
import InlineError from './InlineError'
import Loading from './Loading'
import RetryError from './RetryError'
import { EmptyState, ErrorState } from '../components/ui/feedback-state'
import { cn } from '../lib/cn'

export default function ListContainer({
    loading,
    error,
    onRetry,
    header, // 상단 조작부 (검색/필터/버튼)
    table,  // 표 본문(JSX)
    footer, // 페이지네이션 등 하단부
    emptyText = '표시할 항목이 없습니다',
    emptyTitle,
    emptyDescription,
    emptyAction,
    errorTitle,
    errorDescription,
    useFeedbackState = false,
    className,
}) {
    if (loading) return <Loading />
    if (error) {
        if (useFeedbackState) {
            return (
                <ErrorState
                    title={errorTitle || '잠시 연결이 원활하지 않습니다'}
                    description={errorDescription || error}
                    onAction={onRetry}
                />
            )
        }
        return onRetry ? <RetryError message={error} onRetry={onRetry} /> : <InlineError message={error} />
    }
    return (
        <div className={cn('min-w-0 overflow-x-auto rounded-xl border border-sgez-border-strong bg-sgez-surface', className)}>
            {header}
            {table && (
                <div>
                    {table}
                </div>
            )}
            {!table && (
                useFeedbackState ? (
                    <EmptyState
                        title={emptyTitle || emptyText}
                        description={emptyDescription}
                        action={emptyAction}
                    />
                ) : (
                    <div className="p-4 text-sm text-slate-500">{emptyText}</div>
                )
            )}
            {footer}
        </div>
    )
}
